export default __webpack_public_path__ + "static/media/residency visa nomad.c36e44a8.jpg";